
import React, { useState } from 'react'
import { Button, Form, Input, Space, Card, Tag } from 'antd'
import { useStore } from '@/store'


//导入样式

import '@/scss/common.scss'
import { observer } from 'mobx-react-lite'
import { Customdate } from '@/components'
const App = ({ value, code, index }) => {



    const [Value, SetValue] = useState(value.Value)
    const { DeviceStore } = useStore()

    const [form] = Form.useForm()

    const dic = () => {
        let dic_t = {}
        if (value.DisplayType === "button") {
            value.ValueMap.forEach(element => {
                let color = "red"
                if (element.Value === '1') {
                    color = "green"
                }
                if (element.Value === '2') {
                    color = 'yellow'
                }
                dic_t[element.Value] = <Tag color={color}>{element.DisplayValue}</Tag>
            });
            return dic_t[value.Value]
        } else if (value.DisplayType === "time") {
            return value.Value
        } else {
            return value.Value + value.Unit
        }
    }

    //提交
    const onFinish = async (d) => {
        let values = {}
        values.DevCode = code
        values.FieldName = value.FieldName
        values.ValueType = value.ValueType
        if (d === "提交") {
            values.Value = Value
        } else {
            values.Value = d
        }
        await DeviceStore.getSubmit(values)
    }

    return (
        <Card style={{ margin: "10px" }}
            title={value.DisplayName}
        >
            <Form
                form={form}
                key={index}
            >
                {
                    !value.NotShow && DeviceStore.type.indexOf(value.DisplayType) > -1 && (
                        <>
                            <Form.Item
                                label={'字段名'}
                            >
                                {"[" + value.FieldName + "]"}
                            </Form.Item>
                            <Form.Item
                                label="当前状态"
                            >
                                {dic()}
                            </Form.Item>
                            {value.DisplayType === "time" && (
                                <>
                                    <Form.Item
                                        name="Value"
                                        label="目标值"
                                    >
                                        <Customdate picker="time" dateFormat='HHmm' value={Value} onChange={(e) => { SetValue(e) }} />

                                    </Form.Item>

                                    <Form.Item
                                        label="操作"
                                    >
                                        <Button type="primary" size="small" onClick={() => {

                                            onFinish("提交")

                                        }}> 确定  </Button>
                                    </Form.Item>
                                </>
                            )

                            }

                            {value.DisplayType === "tab" && (
                                <>
                                    <Form.Item
                                        name="Value"
                                        label="目标值"
                                    >
                                        <Input value={Value} onChange={(e) => { SetValue(e.target.value) }} />

                                    </Form.Item>

                                    <Form.Item
                                        label="操作"
                                    >

                                        <Button type="primary" size="small" onClick={() => {
                                            onFinish("提交")
                                        }}> 提交  </Button>
                                    </Form.Item>
                                </>
                            )
                            }


                            {value.DisplayType === "button" && <Form.Item
                                label="操作"
                            >
                                <Space>
                                    {value.ValueMap.map((itema, indexa) => {
                                        let color = "#f50"
                                        if (itema.Value === '1') {
                                            color = "#87d068"
                                        }
                                        if (itema.Value === '2') {
                                            color = '#faad14'
                                        }
                                        return (
                                            <Tag color={color} onClick={() => {

                                                onFinish(itema.Value)

                                            }}>{itema.DisplayValue + itema.Value}</Tag>
                                        )

                                    })
                                    }
                                </Space>
                            </Form.Item>}
                        </>
                    )
                }
            </Form>



        </Card >
    )
}

export default observer(App)